//eslint-enable

import moment from 'moment';

export function dateDiffCalculation(Minute, Minus, format = 'dhm') {
  const formats = {};
  format.split('').forEach((item) => (formats[item.toUpperCase()] = true));

  const dataDiff = moment(Minute).valueOf() - moment(Minus).valueOf(); //时间差的毫秒数
  if (dataDiff > 0) {
    //计算出相差天数
    const days = Math.floor(dataDiff / (24 * 3600 * 1000));
    //计算出小时数
    const leave1 = dataDiff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
    const hours = Math.floor(leave1 / (3600 * 1000));
    //计算相差分钟数
    const leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
    const minutes = Math.floor(leave2 / (60 * 1000));
    //计算相差秒数
    const leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
    const seconds = Math.round(leave3 / 1000);

    let time = '';
    if (days && formats.D) {
      time += days + '天';
    }
    if (hours && formats.H) {
      time += hours + '小时';
    }
    if (minutes && formats.M) {
      time += minutes + '分钟';
    }
    if (seconds && formats.S) {
      time += seconds + '秒';
    }
    //  const dd= moment(`1111-01-${days} ${hours}:${minutes}:${seconds}`).format('YYYY年MM月DD天 HH时mm分钟ss秒')
    return { days, hours, minutes, seconds, secondCount: dataDiff / 1000, formatDate: time };
  }

  return { days: 0, hours: 0, minutes: 0, seconds: 0, secondCount: 0, formatDate: '' };
}

export function formatDate(dateTime, short = false) {
  return dateTime
    ? moment(dateTime).format(short ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss')
    : undefined;
}

export function formatDates(dateTime, short = false) {
  return dateTime ? moment(dateTime).format(short ? 'YYYYMMDD' : 'YYYYMMDD HHmm:ss') : undefined;
}

/** 若超过当天12点就算当前12点到第二天12点 */
export function getToDay(format = ['YYYY-MM-DD 12:00:00', 'YYYY-MM-DD 12:00:00']) {
  const currentTime = new Date().valueOf();
  const currentTime12 = moment(moment(currentTime).format('YYYY-MM-DD 12:00:00')).valueOf(); // 当天12点
  if (currentTime > currentTime12) {
    return [
      moment(moment(currentTime).format(format[0])),
      moment(moment(currentTime).add(1, 'days').format(format[1])),
    ];
  } else {
    return [
      moment(moment(currentTime).add(-1, 'days').format(format[0])),
      moment(moment(currentTime).format(format[1])),
    ];
  }
}

/**
 * @param {*} type type为字符串类型，有两种选择，"s"代表开始,"e"代表结束，dates为数字类型，不传或0代表本周，-1代表上周，1代表下周
 * @param {*} dates
 * @returns
 */
export function getWeekly(type, dates) {
  const now = new Date();
  const nowTime = now.getTime();
  let day = now.getDay();
  let dd;
  const longTime = 24 * 60 * 60 * 1000;
  const n = longTime * 7 * (dates || 0);
  if (type == 's') {
    dd = nowTime - (day - 1) * longTime + n;
  }
  if (type == 'e') {
    dd = nowTime + (7 - day) * longTime + n;
  }
  dd = new Date(dd);
  const y = dd.getFullYear();
  let m = dd.getMonth() + 1;
  let d = dd.getDate();
  m = m < 10 ? '0' + m : m;
  d = d < 10 ? '0' + d : d;
  day = y + '-' + m + '-' + d;
  return { date: day, y, m, d };
}

/** 若超过当天12点就算当前12点到第二天12点 */
export function getToDayTwoDays() {
  const currentTime = new Date().valueOf();
  const currentTime12 = moment(moment(currentTime).format('YYYY-MM-DD 12:00:00')).valueOf(); // 当天12点
  if (currentTime > currentTime12) {
    return [
      moment(moment(currentTime).add(-2, 'days').format('YYYY-MM-DD 12:00:00')),
      moment(moment(currentTime).add(1, 'days').format('YYYY-MM-DD 12:00:00')),
    ];
  } else {
    return [
      moment(moment(currentTime).add(-3, 'days').format('YYYY-MM-DD 12:00:00')),
      moment(moment(currentTime).format('YYYY-MM-DD 12:00:00')),
    ];
  }
}

export function getToDayTwoDays2() {
  const currentTime = new Date().valueOf();
  const currentTime12 = moment(moment(currentTime).format('YYYY-MM-DD 12:00:00')).valueOf(); // 12:00 PM of the current day
  const currentTime13 = moment(moment(currentTime).format('YYYY-MM-DD 00:00:00')).valueOf(); // 12:00 AM of the current day

  if (currentTime13 <= currentTime && currentTime <= currentTime12) {
    // Current time is between 00:00 AM and 12:00 PM
    return [
      moment(moment(currentTime).add(-1, 'days').format('YYYY-MM-DD 12:00:00')),
      moment(moment(currentTime).add(1, 'days').format('YYYY-MM-DD 12:00:00')),
    ];
  } else {
    // Current time is between 12:01 PM and 11:59 PM
    return [
      moment(moment(currentTime).format('YYYY-MM-DD 12:00:00')),
      moment(moment(currentTime).add(2, 'days').format('YYYY-MM-DD 12:00:00')),
    ];
  }
}
export function getYesterdayOrBefore() {
  const currentTime = new Date().valueOf();
  const currentTime12 = moment(moment(currentTime).format('YYYY-MM-DD 12:00:00')).valueOf(); // 12:00 PM of the current day

  if (currentTime12 > currentTime) {
    // 当前时间在十二点钟之前
    return [moment(currentTime).subtract(2, 'days'), moment(currentTime).subtract(2, 'days')];
  } else {
    return [moment(currentTime).subtract(1, 'days'), moment(currentTime).subtract(1, 'days')];
  }
}
